import src from "IMAGE";
export default { src, width: 59, height: 45, blurWidth: 0, blurHeight: 0};
